// Streaming destinations for Medieval Confessions.
// Edit labels / hrefs here — the UI reads from this single source.
export const STREAMING_LINKS = [
  {
    id: "spotify",
    index: "01",
    label: "Listen on Spotify",
    platform: "Spotify",
    href: "https://open.spotify.com/artist/38ytM06M5Uzb0LXkbInz5I",
  },
  {
    id: "apple-music",
    index: "02",
    label: "Listen on Apple Music",
    platform: "Apple Music",
    href: "https://music.apple.com/us/artist/medieval-confessions/1852081529",
  },
  {
    id: "youtube-music",
    index: "03",
    label: "Listen on YouTube Music",
    platform: "YouTube Music",
    href: "https://music.youtube.com/@medievalconfessions",
  },
  {
    id: "amazon-music",
    index: "04",
    label: "Listen on Amazon Music",
    platform: "Amazon Music",
    href: "https://music.amazon.com/artists/B0G1QV7QSH/medieval-confessions",
  },
  {
    id: "youtube",
    index: "05",
    label: "Watch on YouTube",
    platform: "YouTube",
    href: "https://www.youtube.com/channel/UCUcUEv-HFTo-qv8IJMDaveg",
  },
];

// Local, self-contained asset (lives in /public). Kept relative so the
// exported site works on any domain/host without external dependencies.
export const HERO_IMAGE = `${process.env.PUBLIC_URL}/hero.png`;
